import type { OptionMapping } from "@gatsby-plugin-marketplace/fragments/optionMapping"
import type { SaleConfiguration as SaleConfigurationType } from "~/fragments/saleConfigurations"

/**
 * Finds the equivalent variant in another product's sale configuration.
 *
 * Each product in the comparison table can have multiple variants (e.g. 10 GB,
 * 50 GB). Variants share a common `value` key across products — this function
 * uses that key to find the matching variant for a given sale configuration.
 *
 * @param currentPlanSettings - Currently selected variant of the active product.
 * @param saleConfiguration - Sale configuration of the product to search in.
 *
 * @returns Matching variant, `undefined` if not found, or `null` if no variant is selected.
 */
export default function findProductOptions(
  currentPlanSettings: OptionMapping | null,
  saleConfiguration: SaleConfigurationType
): OptionMapping | undefined | null {
  const optionsMapping = saleConfiguration.flatData.optionsMapping || []

  return (
    currentPlanSettings &&
    optionsMapping.find((option) => option.value === currentPlanSettings.value)
  )
}
